export const AUTH_SESSION_HEADER = 'X-Auth-Session';
export const AUTH_SESSION_STORAGE_KEY = 'auth-session-id';

export function normalizeAuthSessionId(value: unknown): string | null {
  if (typeof value !== 'string' ||
      !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value) ||
      value === '00000000-0000-0000-0000-000000000000') {
    return null;
  }
  return value.toLowerCase();
}

export function getAuthSessionId(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return normalizeAuthSessionId(sessionStorage.getItem(AUTH_SESSION_STORAGE_KEY));
  } catch {
    return null;
  }
}
